import * as base from './_base';
import { endpoint } from '@config/api';

export default {
  get: (query, options) => {
    const url = `${endpoint}/account`;
    return base.get(url, query, options);
  },
}